import { useMapVisibility } from 'app/agriculture/hooks/useMapVisibility/useMapVisibility';
import { ToggleableMapVisibility } from 'app/agriculture/contexts/MapVisibilityContextProvider';
import { StackBox } from 'app/agriculture/components/BoxStack/components/StackBox/StackBox';
import { SimpleGrid } from 'app/agriculture/components/SimpleGrid/SimpleGrid';
import { AgCheckbox } from 'app/agriculture/components/form/AgCheckbox/AgCheckbox';

export function ShowOnMapSection() {
    const { isVisible, toggleVisibility } = useMapVisibility();

    return (
        <StackBox.Section
            className="ShowOnMapSection"
            id="show-on-map"
            title="Show on map"
            defaultExpanded={true}
        >
            <SimpleGrid className="CheckboxGroup" columns={2} gap={16}>
                <AgCheckbox
                    id="show-on-map-all"
                    isChecked={isVisible('all')}
                    onChange={(show) => {
                        toggleVisibility('all', show);
                    }}
                    label={'Show all'}
                />
                {ToggleableMapVisibility.map((key) => (
                    <AgCheckbox
                        key={key}
                        id={`show-on-map-${key.replace(' ', '-').toLowerCase()}`}
                        isChecked={isVisible(key)}
                        onChange={(show) => {
                            toggleVisibility(key, show);
                        }}
                        label={key}
                    />
                ))}
            </SimpleGrid>
        </StackBox.Section>
    );
}
